import { Body, Button, Modal, ModalBody, Subhead } from '@growtherapy/sprout-ui';

type ConsentModalProps = {
  onClose: () => void;
  recordOptIn: () => void;
  isOpen: boolean;
};

export const ConsentModalText = {
  HEADING: 'Enable transcription so you can focus on your clients.',
  SUBTITLE:
    'Enabling this feature will request transcription consent from your client. Please be aware that the transcription and summarization technology can make mistakes.',
  ENABLE_BUTTON: 'Yes, enable',
  DONT_ENABLE_BUTTON: "No, don't enable",
  FOOTER: 'You can change this setting any time in your dashboard.',
};

export function ConsentModal({ onClose, recordOptIn, isOpen }: ConsentModalProps) {
  return (
    <Modal
      onClose={onClose}
      onOutsideClick={onClose}
      isOpen={isOpen}
      className='shadow-none sm:max-w-[31rem] md:max-w-[31rem] sm:top-[25%] rebrand:bg-surface-inverse'
    >
      <ModalBody className='flex flex-col items-center gap-8 p-8 text-center'>
        <div className='flex flex-col gap-2 items-center'>
          <Subhead.Default as='h2' className='rebrand:text-text-inverse'>
            {ConsentModalText.HEADING}
          </Subhead.Default>
          <Body.Default className='rebrand:text-text-inverse'>{ConsentModalText.SUBTITLE}</Body.Default>
        </div>
        <div className='w-full flex  flex-col gap-4 items-center text-center'>
          <div className='flex flex-col sm:flex-row gap-4 sm:gap-8 w-full'>
            <Button onClick={onClose} use='primary' className='w-full rebrand:border-border-default'>
              {ConsentModalText.DONT_ENABLE_BUTTON}
            </Button>
            <Button onClick={recordOptIn} use='secondary' className='w-full m-0'>
              {ConsentModalText.ENABLE_BUTTON}
            </Button>
          </div>
          <Body.Small className='rebrand:text-text-inverse'>{ConsentModalText.FOOTER}</Body.Small>
        </div>
      </ModalBody>
    </Modal>
  );
}
